import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { authService } from 'src/services/auth';
import { LoadingScreen } from 'src/components/loading-screen';
import useSessionStore from 'src/store/useSessionStore';
import { useLocation } from 'react-router-dom';

export default function AuthGuard({ children, requireAuth = true }) {
  const [authenticated, setAuthenticated] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const isSessionExpired = useSessionStore((state) => state.isSessionExpired);
  const setSessionExpired = useSessionStore((state) => state.setSessionExpired);
  const location = useLocation();
  const isSweepstakePage = location.pathname === '/sweepstake.aspx';

  useEffect(() => {
    let mounted = true;

    const checkAuth = async () => {
      try {
        if (isSessionExpired) {
          if (mounted) {
            setAuthenticated(false);
            setIsLoading(false);
          }
          return;
        }

        const urlToken = authService.getTokenFromUrl();
        if (urlToken) {
          authService.setToken(urlToken);
          authService.removeTokenFromUrl();
        }
        const isAuth = authService.isAuthenticated();

        if (mounted) {
          setAuthenticated(isAuth);
          setIsLoading(false);
          if (!isAuth && requireAuth && !isSweepstakePage) {
            setSessionExpired(true);
          }
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        if (mounted) {
          setAuthenticated(false);
          setIsLoading(false);
          if (requireAuth && !isSweepstakePage) {
            setSessionExpired(true);
          }
        }
      }
    };

    checkAuth();

    return () => {
      mounted = false;
    };
  }, [isSessionExpired, setSessionExpired, requireAuth, isSweepstakePage]);

  if (isLoading) {
    return <LoadingScreen />;
  }
  if (isSweepstakePage || !requireAuth || authenticated) {
    return children;
  }
  return null;
}

AuthGuard.propTypes = {
  children: PropTypes.node,
  requireAuth: PropTypes.bool
};